<template>
  <div class="button-switch">
    <div
      v-for="option in options"
      :key="option.value"
      class="button-switch-option"
      :class="{ active: value === option.value }"
      @click="onSelect(option.value)"
    >
      {{ option.label }}
    </div>
  </div>
</template>
<script lang="ts" setup>
interface ButtonSwitchProps {
  value: string | number
  options: {
    label: string
    value: string | number
  }[]
}

const props = defineProps<ButtonSwitchProps>()
const emit = defineEmits(['update:value', 'change'])

function onSelect(val: string | number) {
  emit('update:value', val)
  emit('change', val)
}
</script>
<style lang="scss" scoped>
.button-switch {
  padding: 4px;
  background-color: var(--back-3);
  display: flex;
  border-radius: 8px;
  overflow: hidden;

  .button-switch-option {
    background-color: transparent;
    color: var(--text-1);
    cursor: pointer;
    line-height: 30px;
    padding: 0 16px;
    border-radius: 6px;
    overflow: hidden;
    font-size: 14px;

    &.active {
      background-color: var(--switch-btn-active-bg);
      color: var(--primary-color);
      text-align: center;
      font-weight: bold;
    }
  }
}
</style>
